"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("/var/www/html/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var XLSX = _interopRequireWildcard(require("xlsx/xlsx.mjs"));
var _funnel = require("@/api/funnel");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    department: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      tableData: [],
      loading: false,
      exporting: false
    };
  },
  watch: {
    department: function department(newVal, oldVal) {
      if (!this.dialogVisible) {
        return;
      }
      if (newVal && newVal != oldVal) {
        this.tableData = [];
        this.getTableData();
      }
    }
  },
  methods: {
    getTableData: function () {
      var _getTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loading = true;
              _context.next = 4;
              return (0, _funnel.getNoGuideOrder)(this.department);
            case 4:
              res = _context.sent;
              if (res.data && Array.isArray(res.data)) {
                this.tableData = res.data;
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);
            case 11:
              _context.prev = 11;
              this.loading = false;
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 8, 11, 14]]);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }(),
    // 导出可导未导订单
    onExport: function onExport() {
      if (!this.tableData.length) {
        this.$message({
          type: 'warning',
          message: '无数据不可导出'
        });
        return;
      }
      try {
        this.exporting = true;
        var rows = this.tableData.map(function (row) {
          return {
            订单号: row.order_id,
            产品ID: row.product_id,
            'APP ID': row.app_id,
            渠道号: row.channel,
            导粉部门: row.daofen_department,
            下单时间: row.created_at
          };
        });
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), 'sheet1');
        XLSX.writeFile(wb, "\u53EF\u5BFC\u672A\u5BFC\u8BA2\u5355_".concat(this.department, "_").concat(Date.now(), ".xlsx"));
      } catch (e) {
        console.log(e);
        this.$message({
          type: 'error',
          message: '导出失败'
        });
      } finally {
        this.exporting = false;
      }
    }
  }
};